export interface QuotesFeatureRoutesConfig {
  path: string;
}

export const defaultQuotesFeatureRoutesConfig: QuotesFeatureRoutesConfig = {
  path: 'quotes',
};
